// extracted by mini-css-extract-plugin
export default {"table":"HeU0qtlAH_BPAHtZlMsz","striped":"gfJO_AGkBsNbaPjMedoQ","infinitePagination":"jfU8wDpaGHaJEz5qM0aa"};